module.exports = __webpack_public_path__ + "static/media/138.f39f0d0e.png";